import { useLanguage } from '@contexts/LanguageContext';
import SidebarFilm from '../SidebarFilm';
import { resolveFirstLoginCopy } from '../i18n';
import StepHeading from '../StepHeading';
import type { FilmCopyVariant, FilmVariant } from '../types';

interface StepFilmProps {
  variant: FilmVariant;
  copy: FilmCopyVariant;
}

/** Last step: nothing to fill in. Shows where things live in the real app frame. */
export default function StepFilm({ variant, copy }: StepFilmProps) {
  const { language } = useLanguage();
  const t = (key: string) => resolveFirstLoginCopy(language, key);

  return (
    <div className="flex flex-col gap-4">
      <StepHeading heading={t(`film.${copy}.heading`)} lead={t(`film.${copy}.lead`)} />
      <SidebarFilm variant={variant} caption={t(`film.${copy}.caption`)} />
    </div>
  );
}
